module.exports = __webpack_public_path__ + "static/media/taskrabbit.2d51632d.svg";